import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/articles';

export default function ArticleList() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <div className="site-container">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '影视资讯' },
            ]}
          />

          <div className="mb-8">
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              影视资讯
            </h1>
            <p className="text-sm text-foreground-500 mt-1">最新影视动态、深度影评与观影指南</p>
          </div>
        </div>

        <div className="bg-background-100 py-8 md:py-10">
          <div className="site-container">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
                  >
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src={article.cover}
                        alt={article.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-5">
                      <div className="flex items-center gap-2 mb-2 flex-wrap">
                        <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                          {article.category}
                        </span>
                        <span className="text-xs text-foreground-500">{article.date}</span>
                      </div>
                      <h2 className="text-base font-semibold text-foreground-900 leading-snug mb-2 font-heading group-hover:text-primary-600 transition-colors">
                        {article.title}
                      </h2>
                      <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                        {article.summary}
                      </p>
                      <div className="flex items-center gap-1 mt-3 text-xs text-primary-600 font-medium">
                        <span>阅读全文</span>
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-16">
                <p className="text-foreground-500 text-sm">暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: "影视资讯 - 蚂蚁影视",
            description: "蚂蚁影视最新影视动态、深度影评与观影指南",
            isPartOf: {
              "@type": "WebSite",
              name: "蚂蚁影视",
              url: "https://www.mantfilm.com"
            }
          }, null, 2)
        }}
      />
    </>
  );
}